import { RENOMEAR_ITEM } from '../data/renomear-item'
import * as z from 'zod'
import { useSnackbar } from '@tecsinapse/cortex-react'
import {
  GetPastaQuery,
  RenomearItemMutationMutation,
  RenomearItemMutationMutationVariables
} from '@/core/types/graphql'
import { SubmitHandler, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { t } from '@lingui/core/macro'
import { request } from '../../../core/utils/request'
import { useMutation, useQueryClient } from '@tanstack/react-query'

type useRenomearDialogProps = {
  pastaAtual: GetPastaQuery['pasta']
  close: () => void
}

export const useRenomearDialog = ({
  pastaAtual,
  close
}: useRenomearDialogProps) => {
  const client = useQueryClient()

  const renomearItemMutation = useMutation({
    mutationKey: ['renomearItem'],
    mutationFn: async ({
      variables
    }: {
      variables: RenomearItemMutationMutationVariables
    }) =>
      await request<
        RenomearItemMutationMutation,
        RenomearItemMutationMutationVariables
      >(RENOMEAR_ITEM, { variables }),
    onSuccess: async () => {
      await client.refetchQueries({ queryKey: ['itemsPorPasta'] })
      await client.refetchQueries({ queryKey: ['buscaBibliotecaPaged'] })
      await client.refetchQueries({ queryKey: ['pastasPermissaoEscrita'] })
      await client.refetchQueries({ queryKey: ['ultimosModificados'] })
      await client.refetchQueries({ queryKey: ['ultimosModificadosExpanded'] })
      await client.refetchQueries({ queryKey: ['pasta'] })
    }
  })

  const { snackbar } = useSnackbar()

  const form = useForm({
    values: { novoNome: pastaAtual?.nome ?? '' },
    resolver: zodResolver(
      z.object({
        novoNome: z.string({ error: t`O Novo Nome é obrigatório` })
      })
    )
  })

  const onSubmit: SubmitHandler<{ novoNome: string }> = async values => {
    try {
      console.log('variables', {
        idItemBiblioteca: pastaAtual?.id ?? '',
        novoNome: values.novoNome
      })
      await renomearItemMutation.mutateAsync({
        variables: {
          idItemBiblioteca: pastaAtual?.id ?? '',
          novoNome: values.novoNome
        }
      })

      snackbar.show('success', t`Item renomeado com sucesso!`)

      form.reset()
      close()
    } catch {
      snackbar.show('error', t`Erro ao renomear item`)
    }
  }

  const closeForm = () => {
    form.reset()
    close()
  }

  return {
    form,
    onSubmit,
    closeForm
  }
}
